import { ICONS, type IconName } from './icons'

export interface IconProps {
  name: IconName
  /** Size in px (default 20). */
  size?: number
  /** Screen-reader text. Without it the icon is decorative (aria-hidden). */
  label?: string
  className?: string
}

/** Design-system icon. Color = currentColor (inherits from text). */
export function Icon({ name, size = 20, label, className }: IconProps) {
  const Component = ICONS[name]
  return (
    <Component
      size={size}
      strokeWidth={2}
      className={['ui-icon', className].filter(Boolean).join(' ')}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    />
  )
}
